import { ActiveLookup } from '@ag-common-lib/lib/models/crm/lookup.model';
import { LookupBase } from '@ag-common-lib/lib/models/utils/lookup-base.model';

export const normalizeLookup = (activeLookup: Partial<ActiveLookup>[], byValue = false): LookupBase[] =>
  activeLookup.map(({ dbId, value, description }) => ({ value: byValue ? value : dbId, description: description }));
